import * as React from 'react';
import { useSelector } from 'react-redux';
import { RETRY_DEPOSIT_ACCOUNT_PAYMENT } from '../../../../actions/depositAccount';
import { selectDepositAccountPaymentStatus } from '../../../../selectors/depositAccount';
import { sendEvent } from '../../../../utils';
import { PaymentStatus } from './PaymentStatus';

export const PaymentStatusContainer = () => {
  const status = useSelector(selectDepositAccountPaymentStatus);

  const handleRetryClick = () => {
    sendEvent(RETRY_DEPOSIT_ACCOUNT_PAYMENT);
  };

  if (!status) {
    return null;
  }

  return <PaymentStatus status={status} handleRetryClick={handleRetryClick} />;
};
